export const actionTypes = {
  LOAD_REFERRAL_CONFIG: 'LOAD_REFERRAL_CONFIG',
};

const loadReferralConfig = (referralConfig) => ({
  type: actionTypes.LOAD_REFERRAL_CONFIG,
  referralConfig,
});

export { loadReferralConfig };
